import { useState, useEffect } from "react";
import { NavLink, useNavigate} from "react-router-dom";
import { IoLogIn, IoPersonAddSharp } from "react-icons/io5";
import { Carousel } from 'react-responsive-carousel';
import axios from "axios";
import useSWR from "swr";
import ReactPaginate from "react-paginate";
import { NumericFormat } from "react-number-format";

const Landingpage = () => {
  const [products, setProducts] = useState([]);
  const [url, setUrl] = useState("");
  const [companyname, setCompanyName] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keywordname, setKeywordName] = useState("");
  const [queryname, setQueryName] = useState("");
  const [keywordmanu, setKeywordManu] = useState("");
  const [querymanu, setQueryManu] = useState("");
  const [keywordserial, setKeywordSerial] = useState("");
  const [queryserial, setQuerySerial] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;
  
  const fetcher_ads = async () => {
    const response = await axios.get(`${API_BASE_URL}/advertisement`);
    return response.data;
  };

  let dataads;
  const { data: ads } = useSWR("ads", fetcher_ads);
  if (!ads) {
    dataads = null;
  }else{
    dataads = ads;
  };

  useEffect(() => {
      const fetchProducts = async () => {
          try {
              const response = await axios.get(
                `${API_BASE_URL}/homepages?search_name=${keywordname}&search_serial=${keywordserial}&search_manufacture=${keywordmanu}&page=${page}&limit=${limit}`, 
                {
                  headers: {
                      'X-API-Key': API_KEY
                  },
                }
              );
              setProducts(response.data.result);
              setPage(response.data.page);
              setPages(response.data.totalPage);
              setRows(response.data.totalRows);
          } catch (error) {
              console.error('Error fetching products:', error);
          } finally {
              setLoading(false);
          }
      };

    const getCompany = async () => {
        try {
            //get data sales contract
            const responsedata = await axios.get(`${API_BASE_URL}/companies`);  
            setCompanyName(responsedata.data[0].name);
            setUrl(responsedata.data[0].url);
        } catch (error) {
            console.error(error);
            if (error.response) {
              setMsg(error.response.data.msg);
            }
        }
    };
    getCompany();
    fetchProducts();
  }, [page, keywordname, keywordmanu, keywordserial]);
  
  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
    setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
    );
    } else {
    setMsg("");
    }
  };
  function toggleBurgerMenu() {
    document.querySelector('.navbar-menu').classList.toggle('is-active');
  }
  const login = () => {
    navigate("/login");
  };
  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordName(queryname);
    setKeywordManu(querymanu);
    setKeywordSerial(queryserial);
  };


  if (loading) {
      return <div>Loading...</div>;
  }
  return (
    <div>
      <nav className="navbar is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <NavLink to="/" className="navbar-item">
            <img src={url} width="40" alt="company logo"/>
            <p className="ml-2 has-text-link is-uppercase has-text-weight-bold">{companyname}</p>
          </NavLink>
          <a role="button" onClick={toggleBurgerMenu} className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasic">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div id="navbarBasicExample" className="navbar-menu">
          <div className="navbar-start">
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">
                Support
              </a>
              <div className="navbar-dropdown">
                <NavLink to="/login" className="navbar-item" onClick={toggleBurgerMenu}>
                    My Ticket
                </NavLink>
                <NavLink to="/login" className="navbar-item" onClick={toggleBurgerMenu}>
                    My Repair History
                </NavLink>            
              </div>
            </div>
           
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              
              <div className="buttons">
                <NavLink to="/register" className="button is-link">
                   <IoPersonAddSharp />&nbsp;Sign up
                </NavLink>      
                <button onClick={login} className="button is-link is-light">
                <IoLogIn />&nbsp;Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className="container">
        <section className="section pt-1 pr-1 pl-1 pb-2">
            <Carousel autoPlay={true} 
                infiniteLoop={true} 
                interval={3000}
                showThumbs={false} 
                stopOnHover={true}>
                {dataads.map((itemads) => (   
                <div key={itemads.uuid}>
                    <figure className="image is-3by1">
                        <img src={itemads.url} />
                    </figure>
                </div>
                ))}
            </Carousel>
        </section> 
        <section className="section pt-1 pr-1 pl-1 pb-0">
          <h1 className="title has-text-centered">Our Products</h1>
          <form onSubmit={searchData}>
            <div className="field has-addons">
              <div className="control is-expanded">
                <input
                  type="text"
                  className="input"
                  value={queryname}
                  onChange={(e) => setQueryName(e.target.value)}
                  placeholder="Search by product name..." />
              </div>
              <div className="control is-expanded">
                <input
                  type="text"
                  className="input"
                  value={queryserial}
                  onChange={(e) => setQuerySerial(e.target.value)}
                  placeholder="Search by serial number..." />
              </div>
              <div className="control is-expanded">
                <input
                  type="text"
                  className="input"
                  value={querymanu}
                  onChange={(e) => setQueryManu(e.target.value)}
                  placeholder="Search by merek..." />
              </div>
              <div className="control">
                <button type="submit" className="button is-info">
                  Search
                </button>
              </div>
            </div>
          </form> 
          <div className="columns mt-2">
                {products.map((item) => (
                    <div key={item.uuid} className="column is-3">
                          <div className="card has-text-centered">
                              <div className="card-content">
                                  <figure className="image is-128x128 is-inline-block">
                                      <img src={item.url} alt="Image" />
                                  </figure>
                                  <p>{item.name.substring(0, 22)+"..."}</p>
                                  <p>Serial: {item.serialnumber}</p>
                                  <p>Rp. <NumericFormat
                                    value={item.price}
                                    displayType="text" // Renders as a <span> instead of an input
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true} /></p>
                              </div>
                          </div>
                    </div>
                ))}
            </div>
            <p className="is-size-7">
                Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
            </p>
            <p className="has-text-centered has-text-danger">{msg}</p>
            <nav
                className="pagination is-centered is-size-7"
                key={rows}
                role="navigation"
                aria-label="pagination"
            >
                <ReactPaginate
                breakLabel="..."
                previousLabel={"< Prev"}
                nextLabel={"Next >"}
                pageCount={Math.min(10, pages)}
                onPageChange={changePage}
                containerClassName={"pagination-list"}
                pageLinkClassName={"pagination-link"}
                previousLinkClassName={"pagination-previous"}
                nextLinkClassName={"pagination-next"}
                activeLinkClassName={"pagination-link is-current"}
                disabledLinkClassName={"pagination-link is-disabled"} />
          </nav>
        </section>       
      </div>
    </div>
  );
};

export default Landingpage;
